export const environment = {
  firebaseConfig: {
    apiKey: 'AIzaSyD9tE5RoAt4Ya0Rc6PEkNs6p39t9TA2T5Y',
    authDomain: 'phiedge-dwmplus.firebaseapp.com',
    projectId: 'phiedge-dwmplus',
    storageBucket: 'phiedge-dwmplus.firebasestorage.app',
    messagingSenderId: '457894165524',
    appId: '1:457894165524:web:3a2e65223780d364fb7b01',
    measurementId: 'G-FRKWC2RF9J'
  },
  production: false,
  downloadURL: 'https://phiedgehriss3.s3.ap-south-1.amazonaws.com/',

  // developmentUrl: 'http://localhost:8086/'
  // developmentUrl: 'http://192.168.0.124:8086/'
    developmentUrl: 'https://uatdwmplusapi.phiedge.co.in/'
};
